export default __webpack_public_path__ + "static/media/iconNeutral.0cc93538.svg";